// ============================================================
// Gemini API ラッパー(クライアント側)
// ============================================================
// セキュリティ上、API キーはサーバー(Edge Function)に置く
// クライアントは Edge Function を呼び出すだけ
// ============================================================

import { supabase } from './supabase';

export interface ExtractTextResult {
  extraction_id: string;
  extracted: Record<string, unknown>;
}

export async function extractText(params: {
  tenantId: string;
  partnerId?: string;
  rawText: string;
  sourceType: 'line' | 'paste' | 'sms' | 'email';
}): Promise<ExtractTextResult> {
  const { data, error } = await supabase.functions.invoke('extract-text', {
    body: {
      tenant_id: params.tenantId,
      partner_id: params.partnerId ?? null,
      raw_text: params.rawText,
      source_type: params.sourceType,
    },
  });
  if (error) throw error;
  return data as ExtractTextResult;
}

export interface PdfPage {
  page_index: number;
  text: string;
  items: Array<{ text: string; bbox: [number, number, number, number] }>;
}

export async function extractPdf(params: {
  tenantId: string;
  partnerId?: string;
  pdfOrderId: string;
  templateId?: string;
  pages: PdfPage[];
}): Promise<ExtractTextResult> {
  const { data, error } = await supabase.functions.invoke('extract-pdf', {
    body: {
      tenant_id: params.tenantId,
      partner_id: params.partnerId ?? null,
      pdf_order_id: params.pdfOrderId,
      template_id: params.templateId ?? null,
      pages: params.pages,
    },
  });
  if (error) throw error;
  return data as ExtractTextResult;
}

export interface ProductSearchResult {
  manufacturer: string;
  product_code: string;
  product_name: string;
  category: string | null;
  size_text: string | null;
  is_discontinued: boolean;
  predecessor_code: string | null;
  successor_code: string | null;
  catalog_url: string | null;
  confidence: number;
}

export async function searchProduct(params: {
  tenantId: string;
  query: string;
  manufacturerHint?: string;
  categoryHint?: string;
}): Promise<ProductSearchResult> {
  const { data, error } = await supabase.functions.invoke('product-search', {
    body: {
      tenant_id: params.tenantId,
      query: params.query,
      manufacturer_hint: params.manufacturerHint ?? null,
      category_hint: params.categoryHint ?? null,
    },
  });
  if (error) throw error;
  return data as ProductSearchResult;
}
